import React, { Fragment, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box, Button, List, ListItem } from "@material-ui/core";
import colors from "../CustomizedUIs/Colors";
import Search from "../search";
import classnames from "classnames";
import CreateAlarmDialog from './dialog-send-message';
import Table from './table';
import TablePagination from '../message/table-pagination';
import DialogSelectionPopover from './dialog-selection';
import ItemDetailDialog from '../alarm/item-detail';
import Snackbar from '../common/snackbar';
import { useDataProvider, useTranslate } from 'react-admin';
import { MESSAGES_TYPE, getTextPagination } from '../utils';

// Images
import icEmail from "../assets/icons/white-email-action-send.png";
import icChevronRight from "../assets/icons/icChevronRight.png";
import icChevronLeft from "../assets/icons/icChevronLeft.png";
import icRefresh from "../assets/icons/icRefresh.png";
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";
import { useSelector } from "react-redux";
import EditDraftScheduleDialog from './dialog-edit-draft-schedule-alarm';
import DialogSendSuccess from '../common/dialog-send-success';


const useStyles = makeStyles((theme) => ({
    selected: {
        backgroundColor: theme.palette.primary.main
    },
    button: {
        marginRight: 20,
        fontSize: 9,
        fontFamily: ' UniviaPro-Bold',
        letterSpacing: '0.36px ',
        lineHeight: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
    },
    lastButton: {
        marginRight: 40,
        fontSize: 9
    },
    btnIconOnly: {
        width: 12,
        height: 12,
        padding: 6,
        border: 'solid 1.5px #e5f1f8',
        borderRadius: 7.5,
        cursor: 'pointer',

        '&:active': {
            opacity: 0.5
        }
    },
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
    textCountPagination: {
        fontSize: 11,
        color: '#4f5064',
        fontFamily: 'UniviaPro-Medium',
        fontWeight: 500,
        letterSpacing: 'normal',
        lineHeight: '13.2px',
        fontStyle: 'normal',
        fontStretch: 'normal'
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    },
    TextBtn: {
        fontSize: 9,
        color: '#ffffff',
        fontFamily: 'UniviaPro-Bold',
        fontWeight: 'Bold',
        letterSpacing: '0.36px',
        lineHeight: '11px',
        fontStyle: 'normal',
        fontStretch: 'normal'
    },
}));

let sort = {
    field: 'id',
    order: 'ASC'
};

// let CURRENT_TYPE = MESSAGES_TYPE.SENT;
// let TABLE_SORT = { field: 'createdAt', order: 'DESC' };
let timeoutDeleted = null;
function Index({ totalItems, setTotalItems, isCreate, isUpdate, isDelete }) {
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [type, setType] = useState(MESSAGES_TYPE.SENT);
    const [openSendMessage, setOpenSendMessage] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [receiver, setReceiver] = useState();
    const [template, setTemplate] = useState([]);
    const [left, setLeft] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [error, setError] = useState();
    const [dialogSuccessMessage, setDialogSuccessMessage] = useState('');
    const [listMessages, setListMessages] = useState();
    const [deleteMsgText, setDeleteMsgText] = useState('');
    const [alarmTone, setAlarmTone] = useState([]);
    const [order, setOrder] = useState({ field: 'createdAt', order: 'DESC' });
    const [editAlarmId, setEditAlarmId] = useState(null);
    const popupState = usePopupState({ variant: 'popper', popupId: 'sendMessageDialog' });
    const sailsSocket = useSelector((state) => state.sailsSocket.io);
    const [openSendAlarm, setOpenSendAlarm] = useState(false);
    const pagination = { page: 1, perPage: 25 }
    const onChange = (nextType) => {
        // CURRENT_TYPE = nextType;
        // switch (CURRENT_TYPE) {
        switch (nextType) {
            case MESSAGES_TYPE.SENT:
                setOrder({ field: 'createdAt', order: 'DESC' });
                break;
            case MESSAGES_TYPE.DRAFT:
                setOrder({ field: 'createdAt', order: 'DESC' });
                break;
            default:
                setOrder({ field: 'createdAt', order: 'DESC' });
                break;
        };
        setSelectedItems([]);
        setType(nextType);

        pagination.page = 1;

        setPage(1);
        // getMessages();
    }

    const [messages, setMessages] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    // Pagination
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState([]);
    const [checkall, setCheckAll] = useState(false)
    const onCheck = (id) => {
        const newMessages = messages.map(item => ({
            ...item,
            checked: item.id === id ? !item.checked : item.checked
        }));
        let isCheckAll = newMessages.filter(item => item.checked).length === messages.length;
        setCheckAll(isCheckAll);
        setMessages(newMessages)
        const newSelectedItems = newMessages.filter(item => item.checked);
        setSelectedItems(newSelectedItems);
    }

    const onEdit = (id) => {
        setEditAlarmId(id);
    }

    const onDelete = (ids) => {
        const newMessages = messages.filter(item => ids.indexOf(item.id) === -1);
        const msgText = ids.length === 1 ? '1 file deleted!' : ids.length + ' files deleted!';
        setSelectedItems([]);
        setMessages(newMessages);
        setDeleteMsgText(msgText);

        timeoutDeleted = setTimeout(() => {
            let URL;
            switch (type) {
                case MESSAGES_TYPE.SENT:
                    URL = 'alarm';
                    break;
                default:
                    URL = 'alarm/draft-schedule';
                    break;
            }
            setDeleteMsgText('');
            dataProvider('DELETE_MANY', URL, {
                ids,
            }).then(res => {
                if (messages.length === ids.length) {
                    if (page === pages.length && page !== 1) {
                        pagination.page = page - 1;
                        setPage(pagination.page);
                    }
                }
                getMessages();
            }).catch(error => {
                console.error('On Delete:', error);
            });
        }, 2000);
    }

    const onUndoDeleted = () => {
        clearTimeout(timeoutDeleted);
        setDeleteMsgText('');
        getMessages();
    }

    const calculateTotalPage = (total, size) => {

        // CALCULATE TOTAL PAGES
        const totalPages = Math.ceil(total / pagination.perPage);
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        setPages(pages);
    }

    const getSentAlarms = () => {
        dataProvider('GET_LIST', 'alarm', {
            filter: {
                // subject: searchText.trim(),
                or: [
                    { subject: { contains: searchText.trim() } },
                    { message: { contains: searchText.trim() } }
                ]
            },
            pagination,
            sort: order,
        }).then((res) => {
            const { data, total } = res;
            const newData = data.map(item => ({
                ...item,
                checked: false
            }));
            setMessages(newData);
            setTotalItems(total);
            setLoadingPage(false);

            calculateTotalPage(total, data.length);
        }).catch(error => console.error('GET MESSAGES ERROR:', error));
    }

    const getDraftAlarms = () => {
        dataProvider('GET_LIST', 'alarm/draft-schedule', {
            filter: {
                or: [
                    { subject: { contains: searchText.trim() } },
                    { message: { contains: searchText.trim() } }
                ],
                isDraft: true
            },
            pagination,
            sort: order,
        }).then(({ data, total }) => {
            setMessages(data);
            setTotalItems(total);
            setLoadingPage(false);

            calculateTotalPage(total, data.length);
        }).catch(error => console.error('GET DRAFT ALARMS ERROR:', error));
    }

    const getScheduledAlarms = () => {
        dataProvider('GET_LIST', 'alarm/draft-schedule', {
            filter: {
                or: [
                    { subject: { contains: searchText.trim() } },
                    { message: { contains: searchText.trim() } }
                ],
                isDraft: false
            },
            pagination,
            sort: order,
        }).then(({ data, total }) => {
            setMessages(data);
            setTotalItems(total);
            setLoadingPage(false);

            calculateTotalPage(total, data.length);
        }).catch(error => console.error('GET SCHEDULED ALARMS ERROR:', error));
    }

    const getMessages = () => {
        setLoadingPage(true);
        switch (type) {
            case MESSAGES_TYPE.SENT:
                getSentAlarms();
                break;
            case MESSAGES_TYPE.DRAFT:
                getDraftAlarms();
                break;
            case MESSAGES_TYPE.SCHEDULED:
                getScheduledAlarms();
                break;
            default:
                break;
        }
    }

    const onChangePage = (nextPage) => {
        if (nextPage !== page) {
            setPage(nextPage);
            pagination.page = nextPage;
            // TODO: Call api
            getMessages();
        }
    }

    const onPrevious = () => {
        if (page > 1) {
            onChangePage(page - 1);
        }
    }

    const onNext = () => {
        if (page < pages.length) {
            onChangePage(page + 1);
        }
    }

    const onRefresh = () => {
        setMessages([]);
        getMessages();
    }

    const onMarkRead = (id) => {
        setOpenSendAlarm(true)
        if (type === MESSAGES_TYPE.SENT) {
            const newMessages = messages.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        status: 1
                    };
                }
                return item;
            });
            setMessages(newMessages);
            dataProvider('GET_ONE', 'alarm', {
                id
            }).then(({ data }) => {
                setListMessages(data);
            }).catch(error => console.error('onMarkRead:', error));
        }
    }

    const onCheckAll = (e) => {
        const newMessages = messages.map(item => {
            if (checkall === false) {
                return {
                    ...item,
                    checked: true
                }
            }
            else {
                return {
                    ...item,
                    checked: false
                }
            }
        });
        const selectedItems = newMessages.filter(item => item.checked);
        const isCheckAll = selectedItems.length === newMessages.length;
        setCheckAll(isCheckAll);
        setMessages(newMessages);
        setSelectedItems(selectedItems);
    }

    const onCloseSendAlarmDialog = (type) => {
        setOpenSendMessage(false)
        setLeft([]);
        onShowSuccessDialog(type);
        onRefresh()
    }

    const getListEntity = () => {
        setLoading(true)
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                data.countResult.entities.map((item, idx) => {
                    item.id = idx
                })
                setLeft(data.countResult.entities)
                setLoadingPage(false)
                setLoading(false)
            })
            .catch(error => {
                setError(error);
                setLoading(false)
                setOpenSendMessage(false)
            })
    }

    const onChangeSortable = (nextSort) => {
        setOrder(nextSort);
    }

    const getListGroup = () => {
        setLoading(true)
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                data.countResult.groups.map((item, idx) => {
                    item.id = idx
                })
                setLeft(data.countResult.groups)
                setLoadingPage(false)
                setLoading(false)
            })
            .catch(error => {
                setError(error);
                setLoading(false)
            })
    }

    const getListCluster = () => {
        setLoading(true)
        dataProvider('GET_LIST', "ClusterAssign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                data.cluster.map(cluster => {
                    cluster.uniqueName = `${cluster.name}-${cluster.entity}-${cluster.group}`
                })
                setLeft(data.cluster)
                setLoadingPage(false)
                setLoading(false)
            })
            .catch(error => {
                setError(error);
                setLoading(false)
            })
    }

    const getListIndividual = () => {
        setLoading(true)
        dataProvider('GET_LIST', "room/assign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        })
            .then(({ data }) => {
                // data.listUser.map(user => {
                //     user.idx = user.id
                //     user.name = `${user.username} - ${user.firstName} ${user.lastName}`
                // })
                data.listRoom.map(room => {
                    room.name += ` - ID: ${room.number}`
                    room.cluster.uniqueName = `${room.cluster.name}-${room.cluster.entity}-${room.cluster.group}`
                })

                var group = data.listRoom.reduce((r, a) => {
                    r[a.cluster.uniqueName] = [...r[a.cluster.uniqueName] || [], a];
                    return r;
                }, {});

                var clusterName = []
                data.listRoom.map(item => {
                    clusterName.push(item.cluster)
                })

                var temp = []
                clusterName.map(cluster => {
                    temp.push(group[cluster.uniqueName])
                })
                var unique = temp.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                })
                var listRoom = []
                unique.forEach(item => {
                    item.map(elem => {
                        elem.uniqueRoomName = `${elem.name} - ${elem.cluster.name}-${elem.cluster.entity}-${elem.cluster.group}`
                    })
                    var array = {
                        name: item[0].cluster.name,
                        rooms: item
                    }
                    listRoom.push(array)
                })
                setLeft(listRoom)
                setLoadingPage(false)
                setLoading(false)
            })
            .catch(error => {
                setError(error);
                setLoading(false)
            })
    }



    const getListTemplate = () => {
        setLoading(true)
        dataProvider('GET_LIST', "alarm-templates", {
            filter: {},
            pagination,
            sort,
        }).then(({ data }) => {
            setTemplate(data)
            setLoading(false)
        }).catch(error => {
            setError(error);
            setLoading(false)
        })
    }

    const selectToAlarmItem = (value) => {
        popupState.close();
        setReceiver(value)
        getListTemplate()
        setLoading(true)
        switch (value) {
            case "Entity":
                getListEntity()
                setOpenSendMessage(true)
                break;
            case "Group":
                getListGroup()
                setOpenSendMessage(true)
                break;
            case "Cluster":
                // getListRoom()
                getListCluster()
                setOpenSendMessage(true)
                break;
            case "Individuals":
                getListIndividual()
                setOpenSendMessage(true)
                break;
        }
        // TODO: Open create form dialog
    }

    const onShowSuccessDialog = (type) => {
        if (!type) return;
        switch (type) {
            case MESSAGES_TYPE.DRAFT:
                setDialogSuccessMessage(translate('resources.alarm.draftSuccess'));
                break;
            case MESSAGES_TYPE.SCHEDULED:
                setDialogSuccessMessage(translate('resources.alarm.scheduleSuccess'));
                break;
            case MESSAGES_TYPE.SENT:
                setDialogSuccessMessage(translate('resources.alarm.sentSuccess'));
                break;
            default:
                break;
        }
    }

    const onCloseEditDraftScheduleDialog = (type) => {
        setEditAlarmId(null);
        onShowSuccessDialog(type);
        onRefresh()
    }

    useEffect(() => {
        if (sailsSocket) {
            sailsSocket.on('user', event => {
                if (event.type === 'updateBadge') {
                    getMessages();
                }
            });
        }
        getMessages();
    }, [sailsSocket, type, order]);

    return (
        <Fragment>
            <ItemDetailDialog
                onClose={() => setListMessages()}
                title={translate(`pos.alarm.alarmDetail`)}
                messages={listMessages}
                open={openSendAlarm}
            />

            <Box p={3} bgcolor='#ffffff'>
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <Box>
                        {
                            isCreate &&
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                {...bindToggle(popupState)}
                                className={classes.button}
                            >
                                <Typography className={classes.TextBtn}>
                                    {translate(`resources.alarm.sendNewAlarm`)}
                                </Typography>
                                <img src={icEmail} width={13} height={13} style={{ marginLeft: 5 }} /></Button>
                        }
                    </Box>
                    <Box flex={1} display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => onChange(MESSAGES_TYPE.SENT)}
                            className={type === MESSAGES_TYPE.SENT ? classnames(classes.button, classes.selected) : classes.button}
                        >{translate(`resources.alarm.sent`)}</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => onChange(MESSAGES_TYPE.DRAFT)}
                            className={type === MESSAGES_TYPE.DRAFT ? classnames(classes.button, classes.selected) : classes.button}
                        >{translate(`resources.alarm.draft`)}</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => onChange(MESSAGES_TYPE.SCHEDULED)}
                            className={type === MESSAGES_TYPE.SCHEDULED ? classnames(classes.button, classes.selected) : classes.button}
                        >{translate(`resources.alarm.schedule`)}</Button>
                        <Search placeholder={translate(`resources.alarm.searchAlarm`)} onChangeText={setSearchText} getList={getMessages} />
                    </Box>
                </Box>
                <Box pt={4} display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <Box display="flex" flexDirection="row" alignItems="center">
                        <Typography className={classes.textCountPagination}>{getTextPagination(messages, pagination, totalItems, translate)}</Typography>
                        <img src={icChevronLeft} alt='' className={classes.btnIconOnly} style={{ marginLeft: 8 }} onClick={onPrevious} />
                        <img src={icChevronRight} alt='' className={classes.btnIconOnly} style={{ marginLeft: 4 }} onClick={onNext} />
                    </Box>
                    <Box display="flex" flexDirection="row" alignItems="center">
                        <img src={icRefresh} alt=''
                            className={classes.btnIconOnly}
                            onClick={onRefresh}
                            style={{ marginRight: 4, width: 16, height: 16, padding: 4 }}
                        />
                        <Typography className={classes.textCountPagination}>{translate(`resources.alarm.refresh`)}</Typography>
                    </Box>
                </Box>
            </Box>
            <DialogSelectionPopover
                popupState={popupState}
                onClose={() => popupState.close()}
            >
                <List style={{ padding: 0 }} component="nav" aria-label="main mailbox folders">
                    <ListItem button onClick={() => selectToAlarmItem('Entity')}>
                        <Box><Typography className={classes.textTab} >{translate(`resources.alarm.entity`)}</Typography></Box>
                        {/* <ListItemText secondary={translate(`resources.alarm.entity`)} secondaryTypographyProps={{ color: 'textPrimary' }} /> */}
                    </ListItem>
                    <ListItem button onClick={() => selectToAlarmItem('Group')}>
                        <Box><Typography className={classes.textTab} >{translate(`resources.alarm.group`)}</Typography></Box>
                        {/* <ListItemText secondary={translate(`resources.alarm.group`)} secondaryTypographyProps={{ color: 'textPrimary' }} /> */}
                    </ListItem>
                    <ListItem button onClick={() => selectToAlarmItem('Cluster')}>
                        <Box><Typography className={classes.textTab} >{translate(`resources.alarm.cluster`)}</Typography></Box>
                        {/* <ListItemText secondary={translate(`resources.alarm.cluster`)} secondaryTypographyProps={{ color: 'textPrimary' }} /> */}
                    </ListItem>
                    <ListItem button onClick={() => selectToAlarmItem('Individuals')}>
                        <Box><Typography className={classes.textTab} >{translate(`resources.alarm.individuals`)}</Typography></Box>
                        {/* <ListItemText secondary={translate(`resources.alarm.individuals`)} secondaryTypographyProps={{ color: 'textPrimary' }} /> */}
                    </ListItem>
                </List>
            </DialogSelectionPopover>
            <CreateAlarmDialog
                open={openSendMessage}
                loadingDialog={loading}
                alarmToneData={alarmTone}
                onClose={onCloseSendAlarmDialog}
                receiver={receiver}
                data={left}
                templateData={template}
            />

            <EditDraftScheduleDialog
                open={editAlarmId !== null}
                onClose={onCloseEditDraftScheduleDialog}
                alarmId={editAlarmId}
                isDraft={type === MESSAGES_TYPE.DRAFT}
                receiver={receiver}
            />

            <DialogSendSuccess
                open={dialogSuccessMessage.length > 0}
                onClose={() => setDialogSuccessMessage('')}
                message={dialogSuccessMessage}
            />

            <Box mt={2.75}>
                <Snackbar
                    id='snackbar-delete-alarm'
                    show={deleteMsgText.length > 0}
                    message={deleteMsgText}
                    undo={onUndoDeleted}
                    onClose={() => setDeleteMsgText('')}
                />
                <Table
                    checkall={checkall}
                    messages={messages}
                    onCheck={onCheck}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCheckAll={onCheckAll}
                    onMarkRead={onMarkRead}
                    selectedItems={selectedItems}
                    type={type}
                    order={order}
                    loading={loadingPage}
                    onChangeSortable={onChangeSortable}
                    isDelete={isDelete}
                    isUpdate={isUpdate}
                />
                <TablePagination
                    currentPage={page}
                    pages={pages}
                    onChangePage={onChangePage}
                    onPrevious={onPrevious}
                    onNext={onNext}
                />
            </Box>
        </Fragment>
    );
}

Index.propTypes = {
    setTotalMessages: PropTypes.func.isRequired
};

export default Index;
